const messages = [
  "Secure online payments · UPI · Cards · Wallets",
  "Complimentary shipping on orders over ₹4,000",
  "Handcrafted with semi-precious crystals · Made in India",
  "New Drop · The Bloom Collection is live",
];

export default function TopBar() {
  return (
    <div
      data-testid="top-announcement-bar"
      className="w-full bg-[#2A2626] text-[#FAF8F5] overflow-hidden"
    >
      <div className="flex whitespace-nowrap marquee-track py-2.5">
        {[...messages, ...messages, ...messages].map((m, i) => (
          <span
            key={i}
            className="mx-8 text-[11px] uppercase tracking-[0.28em] font-sans opacity-90"
          >
            — {m}
          </span>
        ))}
      </div>
    </div>
  );
}
